import Integrations from '../views/manage/Integrations.vue';
import PromoSlides from '../views/manage/PromoSlides.vue';
import Documentations from '../views/manage/Documentations.vue';
import Demo from '../views/manage/Demo.vue';
import Profiles from '../views/profiles/Index.vue';
import Affiliates from '../views/affiliates/Index.vue';
import Payments from '../views/payments/Index.vue';
import { checkauth } from '../Helper';
import store from '../store';

// nuovo profilo e modifica sono pagine: tornando indietro la lista riparte dal suo URL
const ProfileCreate = () => import('../views/profiles/Create.vue');
const ProfileEdit = () => import('../views/profiles/Edit.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		next(response ? undefined : '/login');
	});
}

async function auditGuard(to, from, next) {
	if (!(await checkauth())) return next('/login');
	return next(store.getters['profile/getRole'] === 0 ? undefined : '/');
}

export default [
	{ path: '/manage/audit', name: 'manage-audit', component: () => import('../views/manage/Audit.vue'), beforeEnter: auditGuard },
	{ path: '/trash/:section(orders|items)', name: 'trash', component: () => import('../views/manage/Trash.vue'), async beforeEnter(to, from, next) { next(await checkauth() ? undefined : '/login'); } },
	{
		path: '/manage/profiles',
		name: 'manage-profiles',
		component: Profiles,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{ path: '/manage/profiles/new', name: 'manage-profile-new', component: ProfileCreate, beforeEnter: auth },
	// :id e' l'_id del profilo (24 caratteri esadecimali): "new" non puo' mai finire qui
	{ path: '/manage/profiles/:id([0-9a-fA-F]{24})', name: 'manage-profile-edit', component: ProfileEdit, beforeEnter: auth },
	{
		path: '/manage/affiliates',
		name: 'manage-affiliates',
		component: Affiliates,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		// NB: `name: 'payments'` e' gia' usato da /setting/payments (metodi di pagamento)
		path: '/manage/payments',
		name: 'manage-payments',
		component: Payments,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/manage/integrations',
		name: 'manage-integrations',
		component: Integrations,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/manage/documentations',
		name: 'manage-documentations',
		component: Documentations,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/manage/demo',
		name: 'manage-demo',
		component: Demo,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	{
		path: '/manage/promo-slides',
		name: 'manage-promo-slides',
		component: PromoSlides,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
];
